//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { useGetClientRetailersQuery } from '@campaigns/components/campaign-requests/sampling-campaigns/SamplingCampaignsQueries';
import { CampaignRequestRetailerField } from '@campaigns/components/campaigns-overview/create-campaign-modal/CampaignRequestRetailerField';
import { transformRetailersToDropdownOptions } from '@campaigns/utils/sampling/clientRetailerUtils';
import { BodyBoldText, BodyText } from '@components/atoms/text/Text';

export const PrepaidRetailerSelectionModal = () => {
  const { data: retailers = [] } = useGetClientRetailersQuery(
    transformRetailersToDropdownOptions,
  );

  return (
    <Container>
      <BodyText>
        Reviews collected for this campaign will display on your chosen
        retailer's site, and not your own. All content and data will be
        available in your campaign report.
      </BodyText>
      <RetailerSection>
        <BodyBoldText>Selected Retailer</BodyBoldText>
        <DropdownContainer>
          <CampaignRequestRetailerField
            retailerOptions={retailers}
            shouldShowCheckbox={false}
          />
        </DropdownContainer>
      </RetailerSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacings[3]};
  padding-right: ${({ theme }) => theme.spacings[4]};
`;

const RetailerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[2]};
`;

const DropdownContainer = styled.div`
  width: ${({ theme }) => theme.smallMeasure};
`;
